import React from 'react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { tomos } from '../data/content';
export function TomosSection() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-20" data-id="element-108" data-mp="1kahccnxuzdpt">
      <div className="mx-auto max-w-4xl" data-id="element-109" data-mp="1p4c1i6w8gkwa">
        <div className="text-center" data-id="element-110" data-mp="1u2dj0ne0gc5n">
          <h2 className="font-display text-[1.6rem] font-extrabold leading-tight text-brand-deep sm:text-4xl" data-id="element-111" data-mp="1u1bxtq3a69a7">
            La Enciclopedia: 6 Tomos, un solo protocolo
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[0.95rem] leading-relaxed text-gray-600 sm:mt-4 sm:text-lg" data-id="element-112" data-mp="11d7rd2cvxs6g">
            Cada tomo resuelve una pieza del rompecabezas metabólico, en el
            orden exacto en que tu cuerpo lo necesita.
          </p>
        </div>

        <ol className="mt-8 space-y-3 sm:mt-10 sm:space-y-4" data-id="element-113" data-mp="2hshnewz0wfxp">
          {tomos.map(tomo => <li key={tomo.numero} className="rounded-2xl border border-gray-200 bg-white p-4 text-left sm:flex sm:items-center sm:gap-6 sm:p-6" data-id="element-114" data-mp="2mrc6m00wk6ic">
              <div className="flex items-center justify-between gap-3 sm:contents" data-id="element-115" data-mp="2qlw53fe8jy9t">
                <span className="inline-flex shrink-0 items-center rounded-full bg-brand-soft px-2.5 py-1 font-display text-[0.7rem] font-extrabold uppercase tracking-wide text-brand sm:order-1 sm:px-3 sm:text-xs" data-id="element-116" data-mp="2mkiy31zepp1b">
                  {tomo.numero}
                </span>
                <span className="shrink-0 font-display text-xs font-extrabold text-gray-400 line-through sm:order-3 sm:text-base" data-id="element-117" data-mp="27q60dkex4ns8">
                  {tomo.valor}
                </span>
              </div>

              <div className="mt-2.5 min-w-0 sm:order-2 sm:mt-0 sm:flex-1" data-id="element-118" data-mp="1yxkl4eahwz85">
                <h3 className="font-display text-base font-extrabold leading-snug text-brand-deep sm:text-xl" data-id="element-119" data-mp="1tyr96qauxga3">
                  {tomo.titulo}
                </h3>
                <p className="mt-1.5 text-[0.9rem] leading-relaxed text-gray-600 sm:text-base" data-id="element-120" data-mp="1jzs6rpgoqgvj">
                  {tomo.descripcion}
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-8 max-w-md sm:mt-10" data-id="element-121" data-mp="1fazlioao3erh">
          <CtaButton href="#precio" location="tomos" data-id="element-122" data-mp="1fckei9hc2pn8">
            Quiero los 6 tomos
          </CtaButton>
          <Reassurance className="mt-3" items={['Un solo pago', 'Acceso inmediato', '100% digital']} data-id="element-123" data-mp="11dkqn41naes4" />
        </div>
      </div>
    </section>;
}